import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { UserForm } from '../Forms';
import { Text1 } from '../../../styles';


const UserModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {props.title ? props.title : `${props.user.is_edit ? "Update" : "Create"} User`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.toggleUserModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <UserForm
                user={props.user}
                onSubmit={props.saveUser}
                loading={props.loading}
            />
        </EaseModal>
    )
};

UserModal.defaultProps = {
    user: {}
};

export { UserModal };